import { exists } from '@/api'

export interface BatchSchoolLendCollectionListCondition {
  grade: string
  class: string
  lendDateFrom: string
  lendDateTo: string
  userId: string
  displayFullName: boolean
  outputJournal: boolean
  outputGroupByUserId: boolean
  outputOrder: string
}

export function BatchSchoolLendCollectionListConditionFromJSON(
  json: any
): BatchSchoolLendCollectionListCondition {
  const _json = JSON.parse(json)

  return {
    grade: exists(_json, 'grade') ? _json.grade : '',
    class: exists(_json, 'class') ? _json.class : '',
    lendDateFrom: exists(_json, 'lend_date_from') ? _json.lend_date_from : '',
    lendDateTo: exists(_json, 'lend_date_to') ? _json.lend_date_to : '',
    userId: exists(_json, 'user_id') ? _json.user_id : '',
    displayFullName: exists(_json, 'display_full_name')
      ? _json.display_full_name
      : false,
    outputJournal: exists(_json, 'output_journal')
      ? _json.output_journal
      : false,
    outputGroupByUserId: exists(_json, 'output_group_by_user_id')
      ? _json.output_group_by_user_id
      : false,
    outputOrder: exists(_json, 'output_order') ? _json.output_order : '1'
  }
}
